module.exports = __webpack_public_path__ + "static/img/Joe_Daniher_desktop.6538f21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joe_Daniher_desktop.jpg
// module id = oSBu
// module chunks = 0